// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2V5pW","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2ti1F"};